import * as React from 'react';
import type { UseFormReturn, Path } from 'react-hook-form';
import { FormField, FormLabel } from 'components/ui/form';
import { Checkbox } from 'components/ui/checkbox';

/**
 * Use this component as the label for form fields.
 * You also need to adapt the receiving component label to
 * accept a React.ReactNode as value as we did on the MultiSelectGS component
 */
export function LabelAndCheckbox<T>({
  mainLabel,
  checkBoxLabel,
  checkBoxName,
  form,
}: {
  mainLabel: React.ReactNode;
  checkBoxLabel: React.ReactNode;
  checkBoxName: Path<T>
  form: UseFormReturn<T, any, undefined>
}) {
  return (
    <div className="flex items-center justify-between gap-2">
      <FormLabel className={'font-GilroySemibold text-sm text-slate-800'}>
        {mainLabel}
      </FormLabel>
      <FormField
        control={form.control}
        name={checkBoxName}
        render={({ field }) => (
          <FormLabel
            htmlFor={checkBoxName}
            className={'flex items-center gap-2'}
          >
            {checkBoxLabel}
            <Checkbox
              id={checkBoxName}
              name={field.name}
              onCheckedChange={field.onChange}
              checked={field.value as boolean | "indeterminate" | undefined}
            />
          </FormLabel>
        )}
      />
    </div>
  )
}
